import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";

import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { usersProfile_template } from "../components/templates/usersProfileNew_template";
import { validationsList_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {header} from "./header";

declare var ko: any;
declare var page: any;

    export class users_profile_new extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected editForm: usersProfile_template;
    protected validationsList: validationsList_template;

    protected getModuleName(){
        return "users_profile_new";
    }

    buildContent() : Array<Element>{

        // create the users form
        this.editForm = new usersProfile_template("userProfile", this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("User Profile");
        return [ this.editForm.build()];
    }

    fillPage() : void{

        //this.getFormData();
    }

}



// WEBPACK FOOTER //
// ./js/modules/users_profile_new.ts